<div class="h-full tk-panel-bg pt-4">

  <form [formGroup]="form" autocomplete="off" class="px-4 flex flex-col wrapper">
    <p-password
      [toggleMask]="true"
      [feedback]="false"
      [placeholder]="'change-password.old-password' | translate"
      formControlName="oldPassword"
      autocomplete="false"
    ></p-password>

    <div class="mt-4 text-xs text-left">
      <div class="text-black">{{'password-change-shared.password-requirements-part1' | translate}}</div>
      <div class="tk-c-blue">{{'password-change-shared.password-requirements-part2' | translate}}</div>
    </div>

    <ng-container>
      <p-password
        [toggleMask]="true"
        [feedback]="false"
        [placeholder]="'password-change-shared.new-password' | translate"
        formControlName="newPassword"
        autocomplete="false"
        class="mt-4"
      ></p-password>

      <mat-error 
        *ngIf="newPasswordCtrl.invalid && newPasswordCtrl.dirty"
        id="{{getErrorMessageElementId('newPassword', newPasswordCtrl)}}"
      >
        {{getErrorMessage(newPasswordCtrl)}}
      </mat-error>
    </ng-container>

    <ng-container>
      <p-password
        [toggleMask]="true"
        [feedback]="false"
        [placeholder]="'password-change-shared.repeat-new-password' | translate"
        formControlName="newPasswordRepeat"
        autocomplete="false"
        class="mt-4"
      ></p-password>
  
      <mat-error
        *ngIf="newPasswordRepeatCtrl.invalid && newPasswordRepeatCtrl.dirty"
        id="{{getErrorMessageElementId('newPasswordRepeat', newPasswordRepeatCtrl)}}"
      >
        {{getErrorMessage(newPasswordRepeatCtrl)}}
      </mat-error>
    </ng-container>

    <app-button class="mt-4 w-40" [isLoading]="isLoading" [isFullWidth]="true" [isActive]="!form.pristine"
                innerTextClasses="text-sm" spinnerClasses="my-1.5" label="{{ 'labels.save' | translate | titlecase}}" (click)="onSave()">
    </app-button>
  </form>
</div>
